// extracted by mini-css-extract-plugin
export default {"bookingForm":"bookNowModal_bookingForm__p2ckg","closeBtn":"bookNowModal_closeBtn__Wu7+-","callText":"bookNowModal_callText__SI5ec","logo":"bookNowModal_logo__2yHLX"};